import api from './api';
import { Action, Meeting, ActionItem } from '@/types/Meeting';

// Define interfaces for our types
interface ActionOptions {
  search?: string;
  showCompleted?: boolean;
  hashtag?: string;
  ageRange?: string;
  period?: string;
  includeShared?: boolean;
}

interface ActionsResponse {
  meetings: Meeting[];
  totalPages: number;
  currentPage: number;
  // Add other response properties as needed
}

// Helper function to get the token from local storage
const getAuthToken = () => localStorage.getItem('token');

// Get Actions List with Pagination and Filtering
export const getActions = async (
  page = 1, 
  pageSize = 25, 
  options: ActionOptions = {}
): Promise<ActionsResponse> => {
  const { search = '', showCompleted = false, hashtag = '', ageRange = '', period = '', includeShared = true } = options;
  try {
    const response = await api.get<ActionsResponse>("/actions/", {
      params: { 
        page, 
        pageSize, 
        search,
        showCompleted,
        hashtag,
        ageRange,
        period,
        includeShared
      },
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
    });

    // Map _id to id for each meeting and its actions
    const meetings = response.data.meetings.map((meeting: Meeting) => ({
      ...meeting,
      id: meeting._id,
      actions: meeting.actions.map((action: ActionItem) => ({
        ...action,
        id: action._id
      }))
    }));

    return { ...response.data, meetings };
  } catch (error) {
    console.error("Error fetching actions:", error);
    throw error;
  }
};

interface ActionStatusResponse {
  action: Action | null;
  message?: string;
}

// Update Action Status
export const updateActionStatus = async (
  meetingId: string, 
  actionId: string, 
  completed: boolean
): Promise<ActionStatusResponse> => {
  try {
    const response = await api.put<ActionStatusResponse>(
      `/actions/${meetingId}/action/${actionId}/status`,
      { completed },
      {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
        },
      }
    );

    // Map _id to id in the response
    const action = response.data.action ? {
      ...response.data.action,
      id: response.data.action._id
    } : null;

    return { ...response.data, action };
  } catch (error) {
    console.error("Error updating action status:", error);
    throw error;
  }
};
